import { LitElement, html, css } from 'lit'

export class BundleDiscountProgress extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }

      .bundle-discount-progress {
        background-color: #ffffff;
        padding: 6px 20px;
        display: none;
        flex-direction: column;
        row-gap: 4px;
      }

      .bundle-discount-progress[bundle-discount-enabled='true'] {
        display: flex;
      }

      .bundle-discount-progress p {
        color: #0a0a0a;
        font-family: 'ABC Oracle', 'Arial', 'Helvetica', 'sans-serif';
        font-size: 12px;
        font-weight: 400;
        line-height: 16.8px;
        text-align: center;
        margin: 0;
      }

      .bundle-discount-progress p br {
        display: none;
      }

      .bundle-discount-progress p button {
        background: none;
        border: none;
        color: #0a0a0a;
        padding: 0;
        text-decoration: underline;
        font-family: 'ABC Oracle', 'Arial', 'Helvetica', 'sans-serif';
        font-size: 12px;
        font-weight: 400;
        line-height: 16.8px;
      }

      .bundle-discount-progress ul {
        margin: 8px auto;
        list-style: none;
        display: flex;
        gap: 8px;
        padding-left: 0;
        width: 100%;
      }

      .bundle-discount-progress ul li {
        color: #0a0a0a;
        font-family: 'ABC Oracle', 'Arial', 'Helvetica', 'sans-serif';
        font-size: 12px;
        font-weight: 400;
        height: 20px;
        background-color: #f4f4f2;
        border-radius: 100px;
        width: 33.3333%;
        padding: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.3s;
        border: 1px solid #077f61;
      }

      .bundle-discount-progress ul li[active] {
        color: white;
        background-color: #077f61;
        transition: 0.3s;
      }

      .open-offer-button {
        cursor: pointer;
      }

      @media (min-width: 768px) {
        .bundle-discount-progress p br {
          display: inherit;
        }
      }
    `,
  ]

  static properties = {
    subscriptionItemsTotalQuantity: { type: Number },
    testOffer: { type: Boolean },
  }

  connectedCallback() {
    super.connectedCallback()
    this.subscriptionItemsTotalQuantity = this.subscriptionItemsTotalQuantity ?? 0
    this.testOffer = this.testOffer ?? false
  }

  _renderBundleDiscountTrack() {
    if (this.subscriptionItemsTotalQuantity === 1) {
      return html` <ul class="bundle-discount-list">
        <li active>20% OFF</li>
        <li>25% OFF</li>
        <li>30% OFF</li>
      </ul>`
    } else if (this.subscriptionItemsTotalQuantity === 2) {
      return html` <ul class="bundle-discount-list">
        <li active>20% OFF</li>
        <li active>25% OFF</li>
        <li>30% OFF</li>
      </ul>`
    } else if (this.subscriptionItemsTotalQuantity >= 3) {
      return html` <ul class="bundle-discount-list">
        <li active>20% OFF</li>
        <li active>25% OFF</li>
        <li active>30% OFF</li>
      </ul>`
    }
  }

  _renderBundleDiscountText() {
    if (this.subscriptionItemsTotalQuantity === 1) {
      return html`<span>Add 1 more subscription to unlock an extra 25% off your first month.</span>`
    } else if (this.subscriptionItemsTotalQuantity === 2) {
      return html`<span>Add 1 more subscription to unlock an extra 30% off your first month.</span>`
    } else if (this.subscriptionItemsTotalQuantity >= 3) {
      return html`<span>You’ve unlocked 30% off your first month of your subscription!</span>`
    }
  }

  _openOffer() {
    window.MicroBus.emit('offer-drawer:open')
    if (window?.gtag) {
      window.gtag('event', 'Offer Drawer - Cart', {})
    }
    window.MicroBus.emit('igEvents:push', {
      event: 'Offer Drawer - Cart',
    })
  }

  render() {
    if (this.testOffer == 'true') {
      return html`
        <div
          class="bundle-discount-progress"
          bundle-discount-enabled="${this.subscriptionItemsTotalQuantity > 0 ? 'true' : 'false'}"
        >
          ${this._renderBundleDiscountTrack()}
          <p>
            ${this._renderBundleDiscountText()} <br />Use code: MYPLAN.
            <button
              class="open-offer-button"
              aria-label="Open offer drawer for more information"
              @click=${() => this._openOffer()}
            >
              More Info
            </button>
          </p>
        </div>
      `
    }
  }
}
customElements.define('bundle-discount-progress', BundleDiscountProgress)
